import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const UserService = sdk.getService('UserService');

export const useUserDetail = (userId?: string) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['user', 'detail', userId],
    queryFn: () => UserService.getUser(userId!),
    enabled: !!userId
  });

  return { user: data, isLoading, error };
};
